
<!-- 售后服务 -->
<template>
	<div id="app">
		<HNB active="服务支持"></HNB>
		<div style="max-height: 20.5rem; overflow: hidden; display: flex; justify-content: center; align-items: center;">
			<img style="width: 100%; " :src="img1"> 
			</div>
		<div id="center">
		
			<ul>
				<li v-for="(item,i) in total" :key="i">
					<router-link :to="item.name" class="link">
						<div class="boxone">
							<div class="svgicon">
								<SvgIcon :svg-name="item.svgname" size="90"></SvgIcon>
		
							</div>
							<p><strong>{{item.intro}}</strong></p>
						</div>
					</router-link>
				</li>
		
		
		
			</ul>
		
		
		
		</div>
		<BS :BsTitle="bsTitle"></BS>
		
		
	</div>
</template>

<script>
	
	import SvgIcon from '../components/SvgIcon.vue'
    import HNB from '../components/HeaderNavigationBar.vue'
	import BS from '../components/bottomShow.vue'
	export default {
		name: "app",
		components: {
			HNB,
			SvgIcon,
			BS
			
		},data() {
			return {
				total: [{
						name: '/policy',
						intro: '售后政策',
						svgname: "service"
					},
					{
						name: '/question',
						intro: '产品介绍视频',
						svgname: 'movie'
					},
					{
						name: '/download',
						intro: 'APP下载',
						svgname: 'appDownload'
					},
					{
						name: '/relation',
						intro: '联系我们',
						svgname: 'contactUs'
					},

				],
				bsTitle:['服务支持'],
				img1:this.GLOBAL.imgHost + '/images/background.png',
			}
		}
	}
</script>

<style>
.link {
		text-decoration: none;
	}

	#center {
		width: 100%;
		height: 44.8125rem;
		margin-top: 3%;
	}

	#center ul {
		width: 45.375rem;
		margin: 0 auto;


	}

	#center ul li {
		list-style: none;
		float: left;
		padding: 1.875rem;
	}

	#center ul li p {
		margin: 0 auto;
		position: relative;
		top: 30%;
		font-size: 0.8rem;
		font-family: Alibaba-PuHuiTi-M;
		font-weight: 500;
		color: rgba(24, 24, 24, 1);
		line-height: 1.875rem;
		letter-spacing: 0.125rem;
	}

	#center .svgicon {

		margin: 0 auto;
		position: relative;
		top: 25%;
	}


	#center .boxone {
		width: 15.9375rem;
		height: 15.9375rem;
		background: rgba(244, 244, 244, 1);
		border-radius: 0.0625rem;


	}

	#center .boxone:hover {

		background: white;
		box-shadow: 0rem 1.5625rem 3.125rem 0rem rgba(41, 44, 51, 0.1);
		border-radius: 0.0625rem;

	}
</style>
